"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var wrap_exports = {};
__export(wrap_exports, {
  WrappedError: () => WrappedError,
  isWrappedError: () => isWrappedError,
  isWrappedErrorOf: () => isWrappedErrorOf,
  unwrapErrorCause: () => unwrapErrorCause,
  wrapError: () => wrapError
});
module.exports = __toCommonJS(wrap_exports);
var import_types_generated = require("./types.generated.js");
class WrappedError extends Error {
  constructor(message, cause) {
    super(message);
    Object.setPrototypeOf(this, WrappedError.prototype);
    this.cause = cause;
  }
}
function isWrappedError(value) {
  return value instanceof WrappedError;
}
function isWrappedErrorOf(isA) {
  return function(value) {
    return value instanceof WrappedError && isA(value.cause);
  };
}
function unwrapErrorCause(error) {
  if (isWrappedError(error)) {
    return unwrapErrorCause(error.cause);
  } else {
    return error;
  }
}
function wrapError(error) {
  if (error instanceof Error) {
    return error;
  } else if ((0, import_types_generated.isApiError)(error)) {
    switch (error.type) {
      case "ExpiredAuthorizationError":
        return new WrappedError("Expired authorization token", error);
      case "InvalidAuthorizationError":
        return new WrappedError("Invalid authorization header", error);
      case "MissingAuthorizationError":
        return new WrappedError("Missing authorization header", error);
      case "ForbiddenError":
        return new WrappedError("Insufficient permissions", error);
      case "BadRequestError":
        return new WrappedError(`Bad request: ${error.message}`, error);
      case "NotFoundError":
        return new WrappedError(`Not found: ${error.itemType}: ${error.item}`, error);
      case "DuplicateError":
        return new WrappedError(`Duplicate: ${error.itemType}: ${error.item}`, error);
      case "MapQueryUnsupportedError":
        return new WrappedError(`The map layer does not support that operation: ${error.message}`, error);
      case "InternalError":
        return new WrappedError(`An internal error occurred: ${error.message}`, error);
      case "ValidationError":
        return new WrappedError(`Validation error: ${error.message}`, error);
      case "NetworkError":
        return new WrappedError(`A network error occurred: ${error.message}`, error);
      default:
        return new WrappedError("Unknown error", error);
    }
  } else {
    return new WrappedError("Unknown error", error);
  }
}
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  WrappedError,
  isWrappedError,
  isWrappedErrorOf,
  unwrapErrorCause,
  wrapError
});
//# sourceMappingURL=wrap.js.map
